import React, { useState, useEffect } from "react";
import { CiSearch } from "react-icons/ci";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import clsx from "clsx";

import classes from "./Input.module.css";

const Input = React.forwardRef(
  (
    {
      value,
      setValue,
      search,
      placeholder,
      onKeyDown,
      onChange,
      type,
      className,
      readonly,
      noIcon,
      label,
      name,
      textarea,
      sm,
      ctrlP,
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    // Handle change event
    const handleChange = (e) => {
      if (onChange) {
        onChange(e); // Call the passed onChange function
      } else {
        setValue(e.target.value); // Default behavior if onChange is not provided
      }
    };

    // Handle 'Ctrl + P' keydown event
    useEffect(() => {
      if (ctrlP) {
        const handleKeyDown = (e) => {
          if (e.ctrlKey && e.key === "p") {
            e.preventDefault();
            ref.current?.focus(); // Focus the input field
          }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
          window.removeEventListener("keydown", handleKeyDown);
        };
      }
    }, [ctrlP, ref]);

    return (
      <div
        className={clsx(
          classes.inputContainer,
          className,
          search && classes.searchIconInputContainer,
          sm && classes.sm,
          ctrlP && classes.ctrlP
        )}
      >
        {search && !noIcon && <CiSearch className={classes.searchIcon} />}
        {textarea ? (
          <textarea
            ref={ref}
            name={name}
            value={value}
            onChange={handleChange}
            className={classes.input}
            placeholder={placeholder}
            required
            readOnly={readonly}
            rows={1}
            cols={10}
          ></textarea>
        ) : (
          <input
            ref={ref}
            name={name}
            type={showPassword ? "text" : type || "text"}
            onKeyDown={onKeyDown}
            value={value}
            onChange={handleChange}
            className={classes.input}
            placeholder={placeholder}
            required
            readOnly={readonly}
          />
        )}
        {ctrlP && (
          <div className={classes.ctrlPContainer}>
            <button className={classes.ctrlPButton}>ctrl</button>
            <button className={classes.ctrlPButton}>p</button>
          </div>
        )}
        {type === "password" && (
          <>
            {showPassword ? (
              <FaRegEye
                className={classes.eye}
                onClick={() => setShowPassword((prev) => !prev)}
              />
            ) : (
              <FaRegEyeSlash
                className={classes.eye}
                onClick={() => setShowPassword((prev) => !prev)}
              />
            )}
          </>
        )}

        {search && value && !ctrlP && (
          <MdClose className={classes.close} onClick={() => setValue("")} />
        )}
      </div>
    );
  }
);

export default Input;
